import React from 'react';
import { skinCorrente } from '../../skin';
import { indirizzoImmagine } from '../../utils/immagini';
import './SkinLogo.css';

/**
 * Il marchio dell'intestazione.
 *
 * Qui c'era il logo AETERIUM scritto dentro il codice. AETERIUM e' il
 * fornitore, non il cliente: ogni skin ha il suo marchio, e nessuna deve
 * mostrare quello di un'altra.
 *
 * Arriva dal tenant del dominio (campo logoUrl): un'immagine caricata dal
 * backoffice, o un indirizzo esterno. Se il tenant non ha un
 * logo si mostra il suo nome; se non c'e' nemmeno una skin, non si mostra
 * niente — uno spazio vuoto e' meglio del marchio di qualcun altro.
 *
 * Lo spazio resta della stessa misura anche da vuoto, cosi' l'intestazione
 * non si scompone il giorno in cui il marchio compare.
 */
export default function SkinLogo() {
  const skin = skinCorrente();

  if (skin && skin.logoUrl) {
    return <img src={indirizzoImmagine(skin.logoUrl)} alt={skin.name || ''} className="lvc-logo"/>;
  }
  if (skin && skin.name) {
    return <span className="lvc-logo-testo">{skin.name}</span>;
  }
  return <span className="lvc-logo-vuoto" aria-hidden="true"/>;
}
